module.exports = __webpack_public_path__ + "static/media/19a.5aa5cd97.jpg";